import classNames from 'classnames'
import { ArticlesSectionHeader } from 'components/editorial/articles/ArticlesSectionHeader'
import { ContainerElement } from 'types'

interface Props extends ContainerElement {
  title?: string
  description?: string
}

export function ArticlesSectionContainer({
  title,
  description,
  className,
  children,
}: Props) {
  return (
    <div className={classNames('container flex flex-col gap-4', className)}>
      <ArticlesSectionHeader title={title} description={description} />

      {children}
    </div>
  )
}
